import {
  ThemeProvider as BetterThemeProvider,
  useTheme as useBetterTheme,
} from 'better-themes';

export type ThemePreference = 'dark' | 'light' | 'system';
type Theme = 'dark' | 'light';

export function ThemeProvider({
  children,
  forcedTheme,
}: {
  children: React.ReactNode;
  forcedTheme?: string;
}) {
  return (
    <BetterThemeProvider
      attribute='class'
      disableTransitionOnChange
      forcedTheme={forcedTheme}
    >
      {children}
    </BetterThemeProvider>
  );
}

export const useTheme = () => {
  const {
    theme: rawTheme,
    setTheme,
    systemTheme,
    forcedTheme,
  } = useBetterTheme();

  const themePref = (rawTheme ?? 'system') as ThemePreference;
  const preferred: Theme =
    themePref === 'system' ? (systemTheme ?? 'light') : themePref;
  // `forcedTheme` overrides the stored preference on <html> (marketing and
  // funnel routes force light), so colors and assets must follow it too.
  const theme: Theme =
    forcedTheme === 'dark' || forcedTheme === 'light' ? forcedTheme : preferred;
  const isDark = theme === 'dark';
  const isLight = !isDark;

  return {
    themePref,
    theme,
    setThemePref: setTheme as (pref: ThemePreference) => void,
    isDark,
    isLight,
  };
};
